<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Pop"
    }
</script>

<style scoped>

</style>